import React, { Fragment, useEffect, useState } from 'react';
import './home.scss';

import {
  getResultOrigin,
  useRESTDataCache,
  ResultProvider,
  getPlace,
  getExcludes,
  getData,
} from '@atresmedia/elections_modules_library/dist/dataProvider';
import {
  TYPES,
  SUBTYPES,
} from '@atresmedia/elections_modules_library/dist/envs';
import Cintillo from '@atresmedia/elections_modules_library/dist/components/cintillo';
import CustomMap from '@atresmedia/elections_modules_library/dist/components/homeMap/customMap';
import PactometroCheckSimple from '@atresmedia/elections_modules_library/dist/components/pactometroCheck/pactometroCheckSimple';

import { InfoCintillo } from '../../components/cintillo/text';
import { getRoute, navigateTo } from '../../utils';
import Town from './town';
import Main from './main';
import { getSite } from '../moduleGenerator/utils';
import { PROPERTIES_JSON } from '../../core/constants';

const PactosTxt =
  window.location.hostname
    .replace('localhost', 'lasexta')
    .indexOf('lasexta') === -1
    ? 'Pactos'
    : 'Pactómetro';

const InfoTxt = 'DATOS';

const addRoute = (data, place, community, excludes, reload, params) => {
  return data.map((town) => {
    const route = getRoute(town, community, excludes, reload, params);
    return { ...town, href: route };
  });
};

const Home = ({ match, history, getHeader, onProvinceChange }) => {
  const {
    year,
    type,
    electionNumber,
    community,
    province,
    reload,
    placeId,
    chartType,
    town,
  } = match.params;
  const params = useRESTDataCache(PROPERTIES_JSON(), 'GLOBAL_CONFIG', null);
  const [selectedTarget, setSelectedTarget] = useState(null);

  const [allRegions, setAllRegions] = useState([]);
  const [selectedPlace, setSelectedPlace] = useState({});
  const [mapData, setMapData] = useState([]);

  const elSubtype = SUBTYPES.SINGLE;
  const [autocomple, setAutocomple] = useState('');
  const [communityName, setCommunityName] = useState('');
  const [townName, setTownName] = useState('');
  const [provincePlace, setProvincePlace] = useState(null);
  const [excludes, setExcludes] = useState(null);

  const [resultOrigin, setResultOrigin] = useState({});
  const [lastYear, setLastYear] = useState();

  const tabsTitle =
    (type === TYPES.GENERAL && elSubtype === SUBTYPES.CONGRESS) ||
    type === TYPES.REGIONAL
      ? [InfoTxt, lastYear, PactosTxt]
      : [InfoTxt];

  // Hide label when we are at top level
  const showSelectedPlace = selectedPlace.ineId !== placeId;

  useEffect(() => {
    getResultOrigin(year, type, electionNumber, placeId)
      .then((historicResult) => {
        setResultOrigin(historicResult);

        setLastYear(String(historicResult.historic.year));
      })
      .catch((err) => {
        setLastYear('2017');
      });

    if (type === TYPES.GENERAL) {
      getPlace('typeplace=REGION&parentid=C108&size=1000').then((regions) => {
        setAllRegions(regions.content);
      });
    }
  }, [year, type, electionNumber, placeId]);

  useEffect(() => {
    getData(
      type === TYPES.REGIONAL
        ? province || placeId
        : province || community || placeId
    ).then((place) => {
      setSelectedPlace(place);
    });
  }, [community, province, type, placeId]);

  useEffect(() => {
    if (town) {
      getData(town).then((place) => {
        setTownName(place.name);
      });
    }
  }, [town]);

  useEffect(() => {
    if (province) {
      getData(province).then((place) => {
        setProvincePlace(place);
      });
    }
  }, [province]);

  useEffect(() => {
    if (params) {
      const selected = params.targets.find((tt) => tt.ineId === community);
      setSelectedTarget(selected);
    }
  }, []);

  useEffect(() => {
    if (params) {
      if (params && !selectedTarget) {
        const selected = params.targets.find((tt) => tt.ineId === community);
        setSelectedTarget(selected);
      }
      Promise.all([
        getPlace(`sortby=main&size=60`),
        getPlace(`typeplace=PROVINCE&size=60`),

        getExcludes(type, electionNumber, year, community),
      ]).then(([data, places, _excludes]) => {
        const placesWithRoute = addRoute(
          places.content,
          data.content,
          community,
          _excludes,
          reload,
          params
        );

        setMapData(placesWithRoute);
        setExcludes(_excludes);
      });
      getData(community).then((place) => {
        setCommunityName(place.name);
      });
    }
  }, [community, electionNumber, reload, type, year, params]);

  const goToDetails = (child, event) => {
    if (onProvinceChange) {
      event && event.preventDefault();

      return onProvinceChange(null, child, null, excludes);
    }
    if (!Boolean(parseInt(reload))) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      navigateTo(
        history,
        reload,
        `/${placeId}/${reload}/${year}/${type}/${electionNumber}/${chartType}/${child.grandpaId}/${child.parentId}/${child.ineId}/resultados.html`,
        child,
        community,
        excludes,
        params
      );
    }
  };
  const site = getSite();

  const changeMapSelection = (parent, child, fromMap, event) => {
    if (onProvinceChange) {
      event.preventDefault();
      return onProvinceChange(parent, child, fromMap, excludes);
    }
    if (event && !Boolean(parseInt(reload))) {
      event.preventDefault();
      event.stopPropagation();

      if (community && child && child.ineId !== parent) {
        navigateTo(
          history,
          reload,
          `/${placeId}/${reload}/${year}/${type}/${electionNumber}/${chartType}/${child.parentId}/${child.ineId}/resultados.html`,
          child,
          !fromMap || community,
          excludes,
          params
        );
      } else if (parent && community !== parent) {
        navigateTo(
          history,
          reload,
          `/${placeId}/${reload}/${year}/${type}/${electionNumber}/${chartType}/${parent}/resultados.html`,
          child,
          !fromMap || community,
          excludes,
          params
        );
      }
    }
  };

  if (!params || !selectedTarget) {
    return <div>loading...</div>;
  }

  return (
    <Fragment>
      <div className={`mainWrapper pageHome chart_${chartType}`}>
        {resultOrigin && resultOrigin.primary ? (
          <ResultProvider
            active={resultOrigin.primary.active}
            year={year}
            type={type}
            subtype={elSubtype}
            electionPlace={placeId}
            electionNumber={electionNumber}
            placeId={town || province || community}
            details={Boolean(town)}
          >
            {(dataResult) => {
              return (
                <Fragment>
                  <div className="block">
                    {getHeader ? (
                      getHeader(community, dataResult)
                    ) : (
                      <Cintillo
                        title={`Elecciones ${selectedTarget.name.toLocaleUpperCase()} 2021`}
                        backgroundColor={selectedTarget.backgroundColor[site]}
                        imgProps={{
                          src: selectedTarget.flags.default,
                          alt: `Bandera de ${selectedTarget.Name}`,
                        }}
                        rightSide={
                          <InfoCintillo>
                            <div>
                              ESCRUTINIO:{' '}
                              <span>
                                {dataResult.currentCountPercent &&
                                  dataResult.currentCountPercent.replace(
                                    '.',
                                    ','
                                  )}
                                %
                              </span>
                            </div>
                            <div>
                              Actualizado:{' '}
                              {dataResult.currentCountPercent ? (
                                <span>
                                  {dataResult.updateDate &&
                                    `${dataResult.updateDate.slice(0, -3)} h.`}
                                </span>
                              ) : (
                                <span>--:-- h.</span>
                              )}
                            </div>
                          </InfoCintillo>
                        }
                      ></Cintillo>
                    )}
                    {town ? (
                      <Town
                        history={history}
                        onProvinceChange={onProvinceChange}
                        chartType={chartType}
                        community={community}
                        communityName={communityName}
                        dataResult={dataResult}
                        electionNumber={electionNumber}
                        elSubtype={elSubtype}
                        excludes={excludes}
                        goToDetails={goToDetails}
                        placeId={placeId}
                        province={province}
                        provincePlace={provincePlace}
                        reload={reload}
                        resultOrigin={resultOrigin}
                        tabsTitle={tabsTitle}
                        town={town}
                        townName={townName}
                        type={type}
                        year={year}
                      ></Town>
                    ) : (
                      <Main
                        community={community}
                        town={town}
                        townName={townName}
                        communityName={communityName}
                        autocomple={autocomple}
                        setAutocomple={setAutocomple}
                        onProvinceChange={onProvinceChange}
                        excludes={excludes}
                        reload={reload}
                        placeId={placeId}
                        year={year}
                        type={type}
                        electionNumber={electionNumber}
                        chartType={chartType}
                        province={province}
                        dataResult={dataResult}
                        provincePlace={provincePlace}
                        showSelectedPlace={showSelectedPlace}
                        selectedPlace={selectedPlace}
                        CustomMap={CustomMap}
                        allRegions={allRegions}
                        mapData={mapData}
                        changeMapSelection={changeMapSelection}
                        elSubtype={elSubtype}
                        tabsTitle={tabsTitle}
                        resultOrigin={resultOrigin}
                        PactometroCheckSimple={PactometroCheckSimple}
                        goToDetails={goToDetails}
                      ></Main>
                    )}
                  </div>
                </Fragment>
              );
            }}
          </ResultProvider>
        ) : (
          <div>Loading</div>
        )}
      </div>
    </Fragment>
  );
};

export default Home;
